import { render } from "./ReservationOrders.vue?vue&type=template&id=6af9a63e&scoped=true"
import script from "./ReservationOrders.vue?vue&type=script&lang=js"
export * from "./ReservationOrders.vue?vue&type=script&lang=js"

import "./ReservationOrders.vue?vue&type=style&index=0&id=6af9a63e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6af9a63e"]])

export default __exports__